import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { GeneralInformation } from './contractGeneralInformationSlice'

export interface BaseContract {
  type: 'BaseContract'
  downPaymentInEuroPerMonth: string
  basePriceWithoutVatInEuroPerMonth: string
  basePriceWithVatInEuroPerMonth: string
  workingPriceWithoutVatInCtPerKWh: string
  workingPriceWithVatInCtPerKWh: string
  msbPriceWithoutVatInEuroPerYear: string
  msbPriceWithVatInEuroPerYear: string
  calculatedGridImportInKwhPerYear: string
  calculatedGridExportInKwhPerYear: string
  totalPriceWithVatInEuroPerYear: string
  totalPriceWithoutVatInEuroPerYear: string
  totalConsumptionInKwhPerYear?: string
  productname: string
  feedInRenumerationInCentPerKwh: string
  feedInRenumerationInEuro: string
  bonusInEuro: string
  contractDurationInMonth: string
  fixedPriceEnddate: string
  calculatedGridExportInEuroPerYearWithoutVat: string
  totalDifferenceOfEnergyCostsAndRenumerationInEuroWithoutVat: string
  fixedPriceDurationInMonth: string
  cancellationPeriodInMonth: string
  creditFromReducedGridFee: string
  energyQuality: string
  totalCostsCappedByGridExportPayment: string
  totalCostsNotCappedByGridExportPayment: string
}

export interface CtgContract {
  type: 'CtgContract'
  downPaymentInEuroPerMonth: string
  partPaymentInEuroPerMonthWithVat: string
  totalPriceWithVatInEuroPerYear: string
  totalPriceWithoutVatInEuroPerYear: string
  totalEnergyAmount: string
  productname: string
  contractDurationInMonth: string
  fixedPriceEnddate: string
  fixedPriceDurationInMonth: string
  cancellationPeriodInMonth: string
  energyQuality: string
  ctgMileagePerYear: string
  ctgConsumptionInKwhPerHundred: string
  ctgPercentageChargedAtHome: string
  ctgTotalCostsMinusRenumerartionWithoutVatInEuroPerYear: string
  ctgTotalCostsMinusRenumerartionWithoutVatInEuroPerMonthRounded: string
  totalCostsCappedByGridExportPayment: string
  totalCostsNotCappedByGridExportPayment: string
}

export interface ContractState {
  baseContract: BaseContract
  heatContract: BaseContract
  faf1Contract: BaseContract
  faf2Contract: BaseContract
  ctgContract: CtgContract
  generalInformation: GeneralInformation
}

const initialState: ContractState = {
  baseContract: {
    type: 'BaseContract',
    downPaymentInEuroPerMonth: '',
    basePriceWithoutVatInEuroPerMonth: '',
    basePriceWithVatInEuroPerMonth: '',
    workingPriceWithoutVatInCtPerKWh: '',
    workingPriceWithVatInCtPerKWh: '',
    msbPriceWithoutVatInEuroPerYear: '',
    msbPriceWithVatInEuroPerYear: '',
    calculatedGridImportInKwhPerYear: '',
    calculatedGridExportInKwhPerYear: '',
    calculatedGridExportInEuroPerYearWithoutVat: '',
    totalDifferenceOfEnergyCostsAndRenumerationInEuroWithoutVat: '',
    totalPriceWithVatInEuroPerYear: '',
    totalPriceWithoutVatInEuroPerYear: '',
    totalConsumptionInKwhPerYear: '',
    productname: '',
    feedInRenumerationInCentPerKwh: '',
    feedInRenumerationInEuro: '',
    bonusInEuro: '',
    contractDurationInMonth: '',
    creditFromReducedGridFee: '',
    fixedPriceEnddate: '',
    fixedPriceDurationInMonth: '',
    cancellationPeriodInMonth: '',
    energyQuality: '',
    totalCostsCappedByGridExportPayment: '',
    totalCostsNotCappedByGridExportPayment: ''
  },
  heatContract: {
    type: 'BaseContract',
    downPaymentInEuroPerMonth: '',
    basePriceWithoutVatInEuroPerMonth: '',
    basePriceWithVatInEuroPerMonth: '',
    workingPriceWithoutVatInCtPerKWh: '',
    workingPriceWithVatInCtPerKWh: '',
    msbPriceWithoutVatInEuroPerYear: '',
    msbPriceWithVatInEuroPerYear: '',
    calculatedGridImportInKwhPerYear: '',
    calculatedGridExportInKwhPerYear: '',
    totalConsumptionInKwhPerYear: '',
    totalPriceWithVatInEuroPerYear: '',
    totalPriceWithoutVatInEuroPerYear: '',
    productname: '',
    feedInRenumerationInCentPerKwh: '',
    feedInRenumerationInEuro: '',
    bonusInEuro: '',
    contractDurationInMonth: '',
    creditFromReducedGridFee: '',
    fixedPriceEnddate: '',
    fixedPriceDurationInMonth: '',
    cancellationPeriodInMonth: '',
    energyQuality: '',
    calculatedGridExportInEuroPerYearWithoutVat: '',
    totalDifferenceOfEnergyCostsAndRenumerationInEuroWithoutVat: '',
    totalCostsCappedByGridExportPayment: '',
    totalCostsNotCappedByGridExportPayment: ''
  },
  faf1Contract: {
    type: 'BaseContract',
    downPaymentInEuroPerMonth: '',
    basePriceWithoutVatInEuroPerMonth: '',
    basePriceWithVatInEuroPerMonth: '',
    workingPriceWithoutVatInCtPerKWh: '',
    workingPriceWithVatInCtPerKWh: '',
    msbPriceWithoutVatInEuroPerYear: '',
    msbPriceWithVatInEuroPerYear: '',
    calculatedGridImportInKwhPerYear: '',
    calculatedGridExportInKwhPerYear: '',
    totalConsumptionInKwhPerYear: '',
    totalPriceWithVatInEuroPerYear: '',
    totalPriceWithoutVatInEuroPerYear: '',
    productname: '',
    feedInRenumerationInCentPerKwh: '',
    feedInRenumerationInEuro: '',
    bonusInEuro: '',
    contractDurationInMonth: '',
    creditFromReducedGridFee: '',
    fixedPriceEnddate: '',
    fixedPriceDurationInMonth: '',
    cancellationPeriodInMonth: '',
    energyQuality: '',
    calculatedGridExportInEuroPerYearWithoutVat: '',
    totalDifferenceOfEnergyCostsAndRenumerationInEuroWithoutVat: '',
    totalCostsCappedByGridExportPayment: '',
    totalCostsNotCappedByGridExportPayment: ''
  },
  faf2Contract: {
    type: 'BaseContract',
    downPaymentInEuroPerMonth: '',
    basePriceWithoutVatInEuroPerMonth: '',
    basePriceWithVatInEuroPerMonth: '',
    workingPriceWithoutVatInCtPerKWh: '',
    workingPriceWithVatInCtPerKWh: '',
    msbPriceWithoutVatInEuroPerYear: '',
    msbPriceWithVatInEuroPerYear: '',
    calculatedGridImportInKwhPerYear: '',
    calculatedGridExportInKwhPerYear: '',
    totalConsumptionInKwhPerYear: '',
    totalPriceWithVatInEuroPerYear: '',
    totalPriceWithoutVatInEuroPerYear: '',
    productname: '',
    feedInRenumerationInCentPerKwh: '',
    feedInRenumerationInEuro: '',
    bonusInEuro: '',
    contractDurationInMonth: '',
    creditFromReducedGridFee: '',
    fixedPriceEnddate: '',
    fixedPriceDurationInMonth: '',
    cancellationPeriodInMonth: '',
    energyQuality: '',
    calculatedGridExportInEuroPerYearWithoutVat: '',
    totalDifferenceOfEnergyCostsAndRenumerationInEuroWithoutVat: '',
    totalCostsCappedByGridExportPayment: '',
    totalCostsNotCappedByGridExportPayment: ''
  },
  ctgContract: {
    type: 'CtgContract',
    downPaymentInEuroPerMonth: '',
    partPaymentInEuroPerMonthWithVat: '',
    totalPriceWithVatInEuroPerYear: '',
    totalPriceWithoutVatInEuroPerYear: '',
    totalEnergyAmount: '',
    productname: '',
    contractDurationInMonth: '',
    fixedPriceEnddate: '',
    fixedPriceDurationInMonth: '',
    cancellationPeriodInMonth: '',
    energyQuality: '',
    ctgMileagePerYear: '',
    ctgConsumptionInKwhPerHundred: '',
    ctgPercentageChargedAtHome: '',
    ctgTotalCostsMinusRenumerartionWithoutVatInEuroPerYear: '',
    ctgTotalCostsMinusRenumerartionWithoutVatInEuroPerMonthRounded: '',
    totalCostsCappedByGridExportPayment: '',
    totalCostsNotCappedByGridExportPayment: ''
  },
  generalInformation: {
    pvUnits: [],
    totalConsumptionInKwh: '',
    pvLocationPostalCode: ''
  }
}

function toCamelCase (str: string) {
  return str.replace(/([-_][a-z])/g, group =>
    group.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  )
}

function keysToCamelCase (obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(v => keysToCamelCase(v))
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce(
      (result, key) => ({
        ...result,
        [toCamelCase(key)]: keysToCamelCase(obj[key])
      }),
      {}
    )
  }
  return obj
}
export const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    setBaseContract: (state, action: PayloadAction<BaseContract>) => {
      state.baseContract = keysToCamelCase(action.payload)
    },
    setHeatContract: (state, action: PayloadAction<BaseContract>) => {
      state.heatContract = keysToCamelCase(action.payload)
    },
    setFaf1Contract: (state, action: PayloadAction<BaseContract>) => {
      state.faf1Contract = keysToCamelCase(action.payload)
    },
    setFaf2Contract: (state, action: PayloadAction<BaseContract>) => {
      state.faf2Contract = keysToCamelCase(action.payload)
    },
    setCtgContract: (state, action: PayloadAction<CtgContract>) => {
      state.ctgContract = keysToCamelCase(action.payload)
    },
    setGeneralInformation: (state, action: PayloadAction<GeneralInformation>) => {
      state.generalInformation = keysToCamelCase(action.payload)
    },
    clearBaseContract: () => {
      return { ...initialState, baseContract: initialState.baseContract }
    },
    clearHeatContract: () => {
      return { ...initialState, heatContract: initialState.heatContract }
    },
    clearFaf1Contract: () => {
      return { ...initialState, faf1Contract: initialState.faf1Contract }
    },
    clearFaf2Contract: () => {
      return { ...initialState, faf2Contract: initialState.faf2Contract }
    },
    clearCtgContract: () => {
      return { ...initialState, ctgContract: initialState.ctgContract }
    },
    clearGeneralInformation: () => {
      return { ...initialState, generalInformation: initialState.generalInformation }
    }
  }
})

export const {
  setBaseContract,
  setHeatContract,
  setFaf1Contract,
  setFaf2Contract,
  setCtgContract,
  clearBaseContract,
  clearHeatContract,
  clearFaf1Contract,
  clearFaf2Contract,
  clearCtgContract
} = contractSlice.actions

export default contractSlice.reducer
